import React from 'react'
import './style.css'

import Menu from './Menu'
import { Navbar, Nav, NavItem } from 'react-bootstrap/lib'

const Topbar = (props) => {
  return (
    <Navbar
      fixedTop={true}
      style={{ backgroundColor: '#928043', color: 'white' }}
      collapseOnSelect
    >
      <Menu />
      <MenuRightButtons />
    </Navbar>
  )
}

const MenuRightButtons = () => {
  const userName = JSON.parse(localStorage.getItem('userInfo')).nome_usuario

  return (
    <Nav pullRight={true} style={{ marginRight: '0.3em' }}>
      <NavItem className="menuNavItem" href={'/perfil'}>
        <span className="profileLinkText">{userName}</span>
      </NavItem>
    </Nav>
  )
}

export default Topbar
